<template>
  <div class="jump-warp">
    <div class="jump-header" :class="headerFixedBg == true ? 'fixed-bg' :''">
      <van-row class="jump-navbar">
        <van-col span="20" class="jump-navbar-search">
          <div class="form-group">
            <form @submit.prevent="onSubmit">
              <input
                type="search"
                class="form-control"
                v-model="q"
                placeholder="搜索"
                ref="searchInput"
              />
              <i class="iconfont icon-sousuo" @keyup.13="searchQ" @click="searchQ"></i>
            </form>
          </div>
        </van-col>
        <van-col span="4" class="jump-navbar-arrow">
          <van-icon name="contact" @click="toLogin" />
        </van-col>
      </van-row>
    </div>
    <div>
      <van-swipe class="jump-swipe fixed" :autoplay="3000">
        <van-swipe-item v-for="(item, index) in banner" :key="index" @click="goViews(item.ad_url)">
          <!-- <a :href="item.ad_url==''?'javascript:void(0);':item.ad_url==null?'javascript:void(0);':item.ad_url=='#'?'javascript:void(0);':item.ad_url"><img
          :src="jumucServer + item.pic_url"></a>-->
          <img :src="jumucServer + item.pic_url" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="notice">
      <ul>
        <li v-for="(item, index) in top10Article">
          <a :href="'#/info/infoId?infoId='+item.id" style="color: #fff">
            <i class="iconfont icon-notice"></i>
            {{item.title}}
          </a>
        </li>
      </ul>
    </div>
    <van-row class="jump-menu-hd">
      <van-col span="6" class="jump-menu">
        <a :href="'#/goodlist?goodsClassId='+goodsClassId.finishedFeed">
          <span class="icon-hd bg-orange"><i class="iconfont icon-cangku"></i></span>
          <!-- <span>
            <img class="homeimg" src="../assets/wuyi/bai.png" />
          </span> -->
          <span>成品饲料</span>
        </a>
      </van-col>
      <van-col span="6" class="jump-menu">
        <a :href="'#/goodlist?goodsClassId='+goodsClassId.fhyp">
          <!-- <span class="icon-hd bg-purple"><i class="iconfont icon-icon-test"></i></span> -->
          <span>
            <img class="homeimg" src="../assets/wuyi/sl.jpg" />
          </span>
          <span>防护用品</span>
        </a>
      </van-col>
      <van-col span="6" class="jump-menu">
        <a :href="'#/goodlist?goodsClassId='+goodsClassId.veterinaryDrugs">
          <span class="icon-hd bg-pink"><i class="iconfont icon-yaopin"></i></span>
          <!-- <span>
            <img class="homeimg" src="../assets/wuyi/hao.png" />
          </span> -->
          <span>兽药</span>
        </a>
      </van-col>
      <van-col span="6" class="jump-menu">
        <a :href="'#/goodlist?goodsClassId='+goodsClassId.ranchSupplies">
          <span class="icon-hd bg-green"><i class="iconfont icon-ziyuan"></i></span>
          <!-- <span>
            <img class="homeimg" src="../assets/wuyi/li.png" />
          </span> -->
          <span>牧场用品</span>
        </a>
      </van-col>
      <van-col span="6" class="jump-menu">
        <a :href="'#/goodlist?goodsClassId='+goodsClassId.frozenSemen">
          <span class="icon-hd bg-cyan"><i class="iconfont icon-jingzisperm1"></i></span>
          <!-- <span>
             <img class="homeimg" src="../assets/wuyi/hui.png" />            
          </span> -->
          <span>冻精</span>
        </a>
      </van-col>
      <!--<van-col span="6" class="jump-menu">-->
      <!--<a @click="integralShop">-->
      <!--&lt;!&ndash;<span class="icon-hd bg-blue"><i class="iconfont icon-fenleigongnengleimu"></i></span>&ndash;&gt;-->
      <!--<span ><img class="homeimg" src="../assets/homeing/integralShop.png"/></span>-->
      <!--<span>积分商城</span>-->
      <!--</a>-->
      <!--</van-col>-->

      <van-col span="6" class="jump-menu">
        <a :href="'#/goodlist?goodsClassId='+goodsClassId.testingupplies">
          <span class="icon-hd bg-blue"><i class="iconfont icon-fenleigongnengleimu"></i></span>
          <!-- <span>
            <img class="homeimg" src="../assets/wuyi/dong.png" />
          </span> -->
          <span>检测用品</span>
        </a>
      </van-col>

      <van-col span="6" class="jump-menu">
        <a :href="'#/goodlist?goodsClassId='+goodsClassId.explosionPromotion">
          <span class="icon-hd bg-yellow"><i class="iconfont icon-jiediancuxiao"></i></span>
          <!-- <span>
            <img class="homeimg" src="../assets/wuyi/dong.png" />
          </span> -->
          <span>爆款促销</span>
        </a>
      </van-col>

      <!-- <van-col span="6" class="jump-menu">
        <a :href="'#/game/luckyDraw'">
          
          <span>
            <img class="homeimg" src="../assets/wuyi/chu.png" />
          </span>
          <span>活动抽奖</span>
        </a>
      </van-col>-->

      <van-col span="6" class="jump-menu">
        <a @click="integralShop">
          <span class="icon-hd bg-red"><i class="iconfont icon-shangcheng11"></i></span>
          <!-- <span>
            <img class="homeimg" src="../assets/wuyi/xia.png" />
          </span> -->
          <span>积分商城</span>
        </a>
      </van-col>
    </van-row>
    <div style="width:100%">
      <a :href="'#/gooddetail/6945'"><img style="width:100%;" src="../assets/adver_banner2.png" alt=""></a>      
    </div> 
    <div class="jump-ad" @click="goVideo(advs1.ad_url)">
      <!-- <a :href="advs1.ad_url"> <img :src="advs1.pic_url" width="100%"></a> -->
      <a>
        <img :src="advs1.pic_url" width="100%" />
      </a>
    </div>
    <div class="jump-hot-item">
      <h5>
        爆款促销
        <a :href="'#/goodlist?goodsClassId='+goodsClassId.explosionPromotion" class="hot-more">更多</a>
      </h5>
      <van-row gutter="10">
        <van-col span="8" v-for="(item, index) in baokuan">
          <a :href="'#/gooddetail/'+item.id">
            <p class="jump-item-title">{{item.goodsName}}</p>
            <!-- <p class="jump-item-title">{{item.seoKeywords}}</p> -->
            <img class="jump-item-img" :src="item.imgPath" />
            <p class="price-box">
              <span class="left-price">￥{{item.showPrice | priceFmt}}</span>
              <!-- <span class="right-price">￥{{item.showMarketPrice | priceFmt}}</span> -->
            </p>
          </a>
        </van-col>
      </van-row>
    </div>
    <div class="jump-ad">
      <!--<a :href="advs2.apAccUrl"> <img :src="jmpic2.picUrl" width="100%"></a>-->
      <!-- <a :href="advs2.ad_url"> <img :src="advs2.pic_url" width="100%"></a> -->
      <a :href="advs2.ad_url==''||advs2.ad_url==null?'javascript:void(0);':advs2.ad_url">
        <img :src="advs2.pic_url" width="100%" />
      </a>
    </div>
    <div class="jump-hot-item">
      <h5>
        兽药
        <a :href="'#/goodlist?goodsClassId='+goodsClassId.veterinaryDrugs" class="hot-more">更多</a>
      </h5>
      <van-row gutter="10">
        <van-col span="8" v-for="(item, index) in shouyao">
          <a :href="'#/gooddetail/'+item.id">
            <p class="jump-item-title">{{item.goodsName}}</p>
            <!-- <p>维生素C注射液</p> -->
            <img class="jump-item-img" :src="item.imgPath" />
            <p class="price-box">
              <span class="left-price">￥{{item.showPrice | priceFmt}}</span>
            </p>
          </a>
        </van-col>
      </van-row>
    </div>
    <div class="jump-ad">
      <!--<a :href="advs3.apAccUrl"> <img :src="jmpic3.picUrl" width="100%"></a>-->
      <!-- <a :href="advs3.ad_url"> <img :src="advs3.pic_url" width="100%"></a> -->
      <a :href="advs3.ad_url==''||advs3.ad_url==null?'javascript:void(0);':advs3.ad_url">
        <img :src="advs3.pic_url" width="100%" />
      </a>
    </div>
    <div class="jump-hot-item">
      <h5>
        成品饲料
        <a :href="'#/goodlist?goodsClassId='+goodsClassId.finishedFeed" class="hot-more">更多</a>
      </h5>
      <van-row gutter="10">
        <van-col span="8" v-for="(item, index) in siliao">
          <a :href="'#/gooddetail/'+item.id">
            <p class="jump-item-title">{{item.goodsName}}</p>
            <img class="jump-item-img" :src="item.imgPath" />
            <p class="price-box">
              <span class="left-price">￥{{item.showPrice | priceFmt}}</span>
            </p>
          </a>
        </van-col>
      </van-row>
    </div>
    <div class="app-bottom">
      <van-tabbar v-model="tabActive" active-color="#3c6eeb">
        <van-tabbar-item url="#/home">
          <i slot="icon" class="iconfont icon-shouye"></i>
          首页
        </van-tabbar-item>
        <van-tabbar-item icon="label-o" url="#/cate">
          <i slot="icon" class="iconfont icon-icon-"></i>
          分类
        </van-tabbar-item>
        <van-tabbar-item icon="label-o" url="#/message/center">
          <i slot="icon" class="iconfont icon-ico_msg"></i>
          消息
        </van-tabbar-item>
        <van-tabbar-item icon="cart-o" url="#/cart">
          <i slot="icon" class="iconfont icon-gouwuche1"></i>
          购物车
        </van-tabbar-item>
        <van-tabbar-item icon="contact" url="#/usercent">
          <i slot="icon" class="iconfont icon-ziyuan2"></i>
          我的
        </van-tabbar-item>
      </van-tabbar>
    </div>
    <van-popup
      v-model="showAdArticlePop"
      style="background: transparent;"
      :close-on-click-overlay="false"
    >
      <div style="position:relative">
        <img
          :src="indexArticle.activityImg"
          style="width: 230px;height: 400px"
          @click="activityUrl(indexArticle.activityUrl)"
        />
        <p style="text-align:center;color:#fff;padding:10px 0;font-size:20px;">
          <van-icon name="close" @click="closeAdArticlePop" />
        </p>
      </div>
    </van-popup>
    <!-- 打电话的悬浮框 -->
    <div class="phoneBox" v-show="showPhone" @click="callPhone">
      <van-icon name="close" class="close" color="red" size="18px" @click.stop="showPhone=false" />
      <van-icon name="phone" size="22px" color="#fff" />
      <p>电话咨询</p>
    </div>
  </div>
</template>
<script>
import {
  Swipe,
  SwipeItem,
  Row,
  Col,
  Tabbar,
  TabbarItem,
  NoticeBar,
  Popup,
  Dialog,
  Icon
} from "vant";
import { setInterval, clearInterval, setTimeout } from "timers";
import $ from "jquery";

export default {
  name: "home",
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Row.name]: Row,
    [Col.name]: Col,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [NoticeBar.name]: NoticeBar,
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [Dialog.name]: Dialog
  },
  data() {
    return {
      tabActive: 0,
      headerFixedBg: false,
      banner: [],
      pic: "",
      top10Article: [],
      baokuan: [],
      shouyao: [],
      siliao: [],
      jumucServer: "",
      q: "",
      indexArticle: {},
      showAdArticlePop: false,
      goods: [],
      top10Article: [],
      advs1: {},
      jmpic1: {},
      jmpic2: {},
      jmpic3: {},
      advs2: {},
      advs3: {},
      userId: "",
      noticeTimer: null,
      integralStore: false,
      user_type: localStorage.getItem("user_type"),
      userRole: localStorage.getItem("userRole"),
      goodsClassId: this.$api.goodsClassId,
      isShow: false,
      showPhone: true,
      serviceTel: "" //咨询电话
    };
  },
  //  beforeRouteEnter (to, from, next){
  //     if(localStorage.getItem('userId')!=''&&localStorage.getItem('userId')!=null){
  //        let data=[localStorage.getItem('userId')];
  //        window.webkit.messageHandlers.loginSucc.postMessage(data);
  //    }
  //    next();
  //     // next(vm => {
  //     //     // 通过 `vm` 访问组件实例,将值传入oldUrl
  //     //     vm.oldUrl = from.path
  //     // })
  // },
  // computed:{
  //     isShow (){
  //         if(this.integralStore&&((this.user_type==2&&this.userRole.indexOf('BUYER')>0)|| this.userRole.indexOf('ADMIN')>0
  //         || this.userRole.indexOf('BM')>0)){
  //             return true
  //         }else{
  //         return false
  //       }
  //     }
  // },
  methods: {
    toLogin() {
      // let islogin = localStorage.getItem('userId');
      // if (islogin) {
      //   location.href = '#/usercent'
      // }else{
      this.$api.toLogin();
      // }
    },
    goViews(url) {
      //轮播图的跳转
      if (url == "https://www.wjx.cn/vm/Q3zNsam.aspx") {
        //判断是否登录
        this.$api.post(this.jumuc.user.checkToken, {}, successRes => {
          if (successRes.success) {
            window.location.href = url;
          }
        });
      } else if (url != "" && url != "#") {
        window.location.href = url;
      }
    },
    goVideo(url) {
      if (url != "" && url != "#") {
        window.location.href = url;
      }
    },
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.headerFixedBg = scrollTop > 50 ? true : false;
    },
    searchQ() {
      console.log("执行搜索方法");
      // this.$refs.serachInput.blur();
      location.href = "#/goodlist?q=" + this.q;
    },
    integralShop() {
      var that = this;
      let userId = localStorage.getItem("userId");
      if (!userId) {
        location.href = "#/login";
      } else {
        if (that.integralStore) {
          location.href = "#/integral/home";
        } else {
          that.$toast("积分商城暂未开启，敬请期待");
        }
      }
    },
    noticeScroll() {
      var that = this;
      setTimeout(function() {
        $(".notice ul li:eq(0)").animate(
          {
            marginTop: "-35px"
          },
          500,
          function() {
            $(this)
              .css({ marginTop: "0" })
              .appendTo($(".notice ul"));
            that.noticeScroll();
          }
        );
      }, 2000);
    },
    showAdArticle() {
      if (localStorage.getItem("showAdArticle") == 0) {
        if (JSON.stringify(this.indexArticle) != "{}") {
          this.showAdArticlePop = true;
        } else {//没有弹窗广告
          this.showAdArticlePop = false;
          //版本更新
          if (this.$checkMobile.isAndroid()) {
            window.AppUpdate.checkAppUpdate(
              function() {},
              function() {},
              this.$api.androidUpdateUrl
            );
          }
        }
        localStorage.setItem("showAdArticle", 1);
      }
    },
    closeAdArticlePop() {
      //弹窗关闭
      this.showAdArticlePop = false;
      //版本更新
      if (this.$checkMobile.isAndroid()) {
        window.AppUpdate.checkAppUpdate(
          function() {},
          function() {},
          this.$api.androidUpdateUrl
        );
      }
    },
    activityUrl(url) {
      this.closeAdArticlePop();
      location.href = url;
    },
    getappbank() {
      //版本更新
      var that = this;
      if (that.$checkMobile.isAndroid()) {
        window.AppUpdate.checkAppUpdate(
          function() {},
          function() {},
          that.$api.androidUpdateUrl
        );
      } else {
        that.showAdArticle();
      }
    },
    onSubmit() {
      location.href = "#/goodlist?q=" + this.q;
      return false;
    },
    callPhone() {
      //打电话
      // 判断用户是否登录
      let phoneNumber = "";
      this.$api.post(this.jumuc.user.checkToken, {}, successRes => {
        if (successRes.success) {
          phoneNumber =
            localStorage.getItem("serviceTel") == "undefined"
              ? this.serviceTel
              : localStorage.getItem("serviceTel");
        } else {
          phoneNumber = this.serviceTel;
        }
        Dialog.confirm({
          title: "拨打电话",
          message: phoneNumber
        })
          .then(() => {
            window.location.href = "tel:" + phoneNumber;
          })
          .catch(() => {});
      });
    }
  },
  mounted() {
    this.noticeScroll();
    // var guide = localStorage.getItem("guide")
    // window.addEventListener('scroll', this.handleScroll)
    var that = this;
    // banner 滚动公告 爆款
    try {
      that.jumucServer = localStorage.getItem("jumucServer");
      that.top10Article = JSON.parse(localStorage.getItem("top10Article"));
      that.baokuan = JSON.parse(localStorage.getItem("baokuan"));
      that.shouyao = JSON.parse(localStorage.getItem("shouyao"));
      that.siliao = JSON.parse(localStorage.getItem("siliao"));
      that.banner = JSON.parse(localStorage.getItem("banner"));
    } catch (e) {}

    that.$api.get(that.jumuc.getIndexInfo, null, successRes => {
      if (successRes.success) {
        that.jumucServer = successRes.data.jumucServer;
        that.banner = successRes.data.bannerList;
        that.serviceTel = successRes.data.serviceTelphone;
        localStorage.setItem("phone", this.serviceTel);
        if (that.banner == undefined) {
          that.banner = {};
        }
        if (successRes.data.indexArticle.length > 0) {
          that.indexArticle = successRes.data.indexArticle[0];
        } else {
          that.indexArticle = {};
        }
        that.top10Article = successRes.data.top10Article;
        //that.baokuan = successRes.data.goods.slice(0, 3);
        //爆款 兽药 饲料
        that.baokuan = successRes.data.hotStylePromotion.slice(0, 3);
        localStorage.setItem("baokuan", JSON.stringify(that.baokuan));
        that.shouyao = successRes.data.veterinary.slice(0, 3);
        localStorage.setItem("shouyao", JSON.stringify(that.shouyao));
        that.siliao = successRes.data.fodder.slice(0, 3);
        localStorage.setItem("siliao", JSON.stringify(that.siliao));

        that.advs1 = successRes.data.adv001List[0];
        that.advs2 = successRes.data.adv002List[0];
        that.advs2 = successRes.data.adv002List[0];
        that.advs3 = successRes.data.adv003List[0];
        localStorage.setItem("jumucServer", that.jumucServer);
        localStorage.setItem("banner", JSON.stringify(that.banner));
        localStorage.setItem("top10Article", JSON.stringify(that.top10Article));
        //判断是安卓还是ios
        that.integralStore = navigator.userAgent.match(/android/i)
          ? successRes.data.androidIntegralStore
          : successRes.data.integralStore;
        localStorage.setItem("integralStore", that.integralStore);
      }
      this.showAdArticle();
      //this.getappbank()
    });
    // // 兽药列表
    // that.$api.post(that.jumuc.goodsList, {'goodsClassId': that.goodsClassId.veterinaryDrugs},
    //     successRes => {
    //         if (successRes.success) {
    //             that.shouyao = successRes.data.list.slice(0, 6)
    //             localStorage.setItem('shouyao', JSON.stringify(that.shouyao));
    //         }
    //     })
    // // 成品饲料
    // that.$api.post(that.jumuc.goodsList, {'goodsClassId': that.goodsClassId.finishedFeed},
    //     successRes => {
    //         if (successRes.success) {
    //             that.siliao = successRes.data.list.slice(0, 3)
    //             localStorage.setItem('siliao', JSON.stringify(that.siliao));
    //         }
    //     })
  },
  destroyed() {
    // window.removeEventListener('scroll', this.handleScroll);
  },
  filters: {
    priceFmt(price) {
      if (localStorage.getItem("token") == null) {
        return "会员登录查看";
      } else if (price == null || price == 0) {
        return "已售罄";
      }
      return price;
    }
  }
};
</script>
<style lang="less" scoped>
@bule-thame: #3c6eeb;
.jump {
  &-title {
    width: 30 rpx;
    margin: 10px 20px;
  }
  &-warp {
    padding-bottom: 60px;
    background-color: #f7f7f7;
    width: 100%;
    overflow: hidden;
  }

  &-navbar {
    &-search {
      padding-left: 16px;
      .form-group {
        margin-bottom: 0;
        position: relative;
        i {
          position: absolute;
          top: 6px;
          right: 10px;
          font-size: 12px;
          color: @bule-thame;
        }

        input {
          height: 30px;
          font-family: PingFangSC-Regular;
          color: rgba(60, 110, 235, 0.5);
          font-size: 12px;
          // font-size: 1rem;
          line-height: 30px;
          border-radius: 30px;
          padding-right: 35px;
        }
      }
    }
    &-arrow {
      text-align: center;
      line-height: 40px;
      i.van-icon {
        font-size: 20px;
        color: #ffffff;
        // vertical-align: -6px;
      }
    }
  }
  &-notice {
    color: #fff;
    background-color: @bule-thame;
    overflow: hidden;
    a {
      color: #ffffff;
    }
    .notice-item {
      display: none;
    }
    .notice-item:first-child {
      display: block;
    }
  }
}

.jump-swipe.fixed {
  z-index: 0;
}

.jump-swipe {
  height: 187px;
  img {
    width: 100%;
    display: block;
  }
}

.jump-item-title {
  overflow: hidden;
  text-overflow: ellipsis; /* 文本溢出 ... */
  display: -webkit-box;
  -webkit-line-clamp: 2; /* 规定显示行数... */
  -webkit-box-orient: vertical;
  font-family: PingFangSC-Regular;
  font-size: 12px;
}

.jump-item-img {
  width: 112px;
  height: 112px !important;
  display: block;
}

.price-box {
  clear: both;
  overflow: auto;
  display: block;
  content: "";
  .left-price {
    float: left;
    color: red;
  }
  .right-price {
    float: right;
    color: #888;
    text-decoration: line-through;
  }
}

.jump-menu-hd {
  padding: 10px 0;
  margin-bottom: 10px;
  background-color: #fff;
  .jump-menu {
    padding: 5px;
    font-size: 12px;
    text-align: center;

    span {
      display: block;
      color: rgb(102, 102, 102);
      font-family: PingFangSC-Regular;
      &.icon-hd {
        margin-top: 5px;
        margin-bottom: 8px;
        width: 44px;
        height: 44px;
        line-height: 44px;
        display: inline-block;
        border-radius: 50%;
        background-color: #ff7300;
      }
    }
    .homeimg {
      width: 44px;
      height: 44px;
      line-height: 44px;
      display: inline-block;
      margin-bottom: 8px;
    }
    i.iconfont {
      color: #fff;
      font-size: 24px;
      vertical-align: -4px;
    }
    a {
      display: block;
    }
  }
}

// marquee {
//   background-color: #3c6eeb;
//   display: block;
//   .van-notice-bar__content {
//     font-family: PingFangSC-Regular;
//   }
// }
.notice {
  width: 100%; /*单行显示，超出隐藏*/
  height: 35px; /*固定公告栏显示区域的高度*/
  padding: 0 0px 0 10px;
  background-color: @bule-thame;
  overflow: hidden;

  ul li {
    list-style: none;
    line-height: 35px;
    /*以下为了单行显示，超出隐藏*/
    font-family: PingFangSC-Regular;
    color: #fff;
    display: block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    .iconfont {
      font-size: 18px;
      margin-right: 3px;
      color: #fff;
      background-color: @bule-thame;
      overflow: hidden;
    }
  }
}

.jump-hot-item {
  margin-bottom: 10px;
  img {
    display: block;
    margin-left: auto;
    margin-right: auto;
    max-width: 100%;
    height: auto;
  }
  h5 {
    font-size: 14px;
    height: 16px;
    padding-left: 10px;
    font-family: PingFangSC-Regular;
    color: rgb(102, 102, 102);
    border-left: 5px solid @bule-thame;
    margin-bottom: 10px;
  }
  .van-col {
    margin-bottom: 10px;
    p {
      text-align: center;
      font-size: 14px;
      height: 40px;
    }
    a {
      display: block;
      padding: 10px 0;
      background-color: #fff;
    }
  }
  .hot-more {
    float: right;
    padding-right: 10px;
  }
}

.jump-hot,
.jump-ad,
.jump-featured {
  margin-bottom: 10px;
  img {
    display: block;
    margin-left: auto;
    margin-right: auto;
    max-width: 100%;
    height: auto;
  }
}

.jump-ad {
  width: 100%;
  height: 185px;
  overflow: hidden;
}

.jump-featured {
  &-head {
    padding: 10px 0;
    text-align: center;
    h5 {
      display: inline;
      font-size: 12px;
      position: relative;
      color: #ff8b00;
    }
  }
  &-body {
    div {
      height: 185px;
      padding: 10px;
      border-right: 1px solid #eeeeee;
      border-bottom: 1px solid #eeeeee;
    }
    div:nth-child(-n + 3) {
      border-top: 1px solid #eeeeee;
    }
    a {
      color: #666;
    }
    h5 {
      line-height: 30px;
      font-size: 12px;
      margin: 0;
    }
    h6 {
      font-weight: normal;
      color: #999;
    }
  }
}
.phoneBox {
  position: fixed;
  padding-top: 6px;
  box-sizing: border-box;
  width: 64px;
  height: 64px;
  border-radius: 3px;
  top: 50%;
  transform: translateY(-27px);
  right: 10px;
  text-align: center;
  background: #766969;
  .close {
    position: absolute;
    top: -20px;
    right: -10px;
  }
  p {
    font-size: 12px;
    color: #fff;
  }
}
</style>
